module.exports = __webpack_public_path__ + "img/storm2.9ff25b35.png";